import { apiFetch } from '@ami/react/core';

const dealerGroupUrl = 'dealer-groups-lookup';

export default {
  getById: (id) => {
    return apiFetch(`${dealerGroupUrl}/${id}`, 'GET', null, null, true);
  },
};
